<template>
    <div
        v-on:click.self="expanded = false"
    >
        <div v-bind:class="{'expanded-content': expanded}">
            <a v-if="!expanded" title="Reset" href="./?mcd=0" class="about no-print">
                <font-awesome-icon icon="redo"/>
            </a>
            <AboutPage class="no-print"/>
            <div v-if="expanded">
                <h2>Laborshed</h2>
                <p class="no-print">
                    About Laborshed
                </p>
            </div>
            <div class="group no-print">
                <div class="control-title">Filter Tracts by Community:</div>
                <mcdSelect
                        v-bind:mcd="mcd"
                        v-bind:counties="counties"
                        v-on:mcdInput="setMcd($event)"
                        v-on:countiesInput="setCounties($event)"
                />
            </div>
            <div class="group">
                <div class="control-title">Choose Workers by:<span v-if="selectedAmenity !== 'All_Access_Points'"></span></div>
                <div class="name">
                    <button
                            v-for="name in amenities"
                            v-on:click="selectedAmenity = name"
                            v-bind:disabled="name === selectedAmenity"
                            v-bind:class="{'workplace_button': name === 'Workplace'}"
                            v-bind:key="name">
                      <font-awesome-icon v-if="name==='Residence'" icon="home"/>
                      <img v-if="name==='Workplace'" alt='work' src="../../public/noun_digging_164791.svg" style="height: 1.7em; vertical-align: middle;">
                      {{amenityNames[name].name}}
                    </button>
                </div>
            </div>
          <div class="group">
            <div class="control-title">Choose Category: </div>
            <div v-show="mappedAmenity !== 'Potential'" class="name">
              <button
                  v-for="name in categories"
                  v-on:click="selectedCategory = name"
                  v-bind:key="name"
                  v-bind:disabled="name === selectedCategory">
                {{ categoryNames[name].name }}
              </button>
            </div>
          </div>
          <invertSelect :options="industries"
                        :displayCutoff="1"
                        v-show="mappedAmenity !== 'Potential' && mappedCategory === 'Industry'"
                        v-on:input="$emit('industryInput', $event)"/>
          <invertSelect :options="flow_industries"
                        :displayCutoff="1"
                        v-show="mappedAmenity !== 'Potential' && mappedCategory === 'Flow'"
                        v-on:input="$emit('flowInput', $event)"/>
          <invertSelect :options="occupations"
                        :displayCutoff="1"
                        v-show="mappedAmenity !== 'Potential' && mappedCategory === 'Occupation'"
                        v-on:input="$emit('occupationInput', $event)"/>
          <invertSelect :options="potentialColumns"
                        v-show="mappedAmenity === 'Potential'"
                        v-on:input="$emit('potentialInput', $event)"/>
          <div v-show="mappedCategory === 'Flow'" style="padding:5px;">
            <div class="group">
              <div class="name">
                <button v-bind:disabled="flowDirection === 'Inflow'"
                        v-on:click="flowDirection = 'Inflow'"
                        value="Inflow">Inflow
                </button>
                <button v-bind:disabled="flowDirection === 'Outflow'"
                        v-on:click="flowDirection = 'Outflow'"
                        value="Outflow">Outflow
                </button>
              </div>
            </div>
          </div>

        </div>
    </div>
</template>

<script>
import mcdSelect from "./mcdSelect";
import AboutPage from "./AboutPage";
import InvertSelect from "@/components/InvertSelect";

export default {
        name: "AmenitySelect",
        components: {InvertSelect, mcdSelect, AboutPage},
        props: ['mappedAmenity', 'amenities', 'amenityNames','categories', 'categoryNames', 'mappedCategory', 'counties', 'mcd', 'data_tables', 'data_table', 'modeNames', 'demographicColumn', 'demographicColumns', 'startExpanded', 'flow_tract_selected'],
        data: function () {
            return {
                selectedAmenity: this.mappedAmenity,
                selectedCategory: this.mappedCategory,
                expanded: this.startExpanded,
                flowDirection: this.amenityNames[this.mappedAmenity].defaultFlow || 'Outflow',
            }
        },
  computed: {
    potentialColumns: function () {
      return [
        {name: 'Age 16 to 24', statevalue: 'potential_workers_16_24'},
        {name: 'Age 25 to 64', statevalue: 'potential_workers_25_64'},
        {name: 'Age 65 and up', statevalue: 'potential_workers_65_and_over'},
      ]
    },
    industries: function () {
      return [
        {name: 'Agriculture, forestry, fishing and hunting, and mining', statevalue: 11},
        {name: 'Armed Forces', statevalue: 1},
        {name: 'Arts, entertainment, recreation, accommodation and food services', statevalue: 71},
        {name: 'Construction', statevalue: 23},
        {name: 'Educational, health and social services', statevalue: 65},
        {name: 'Finance, insurance, real estate and rental and leasing', statevalue: 55},
        {name: 'Information', statevalue: 50},
        {name: 'Manufacturing', statevalue: 30},
        {name: 'Other services (except public administration)', statevalue: 80},
        {name: 'Professional, scientific, management, administrative, and waste management services', statevalue: 60},
        {name: 'Public administration', statevalue: 92},
        {name: 'Retail trade', statevalue: 42},
        {name: 'Transportation and warehousing, and utilities', statevalue: 43},
        {name: 'Wholesale trade', statevalue: 41},
      ]
    },
    flow_industries: function () {
      return [
        {name: 'Education and Health Services', statevalue: 65, industry_codes: [65]},
        {name: 'Information, Financial Activities, & Professional and Business Services', statevalue: 20, industry_codes: [55, 50, 60]},
        {name: 'Leisure and Hospitality', statevalue: 71, industry_codes: [71]},
        {name: 'Manufacturing', statevalue: 30, industry_codes: [30]},
        {name: 'Natural Resources, Mining, Construction, & Armed Forces', statevalue: 10, industry_codes: [11,23,1]},
        {name: 'Other Services & Public Administration', statevalue: 90, industry_codes: [80, 92]},
        {name: 'Trade, Transportation, and Utilities', statevalue: 40, industry_codes: [41, 42, 43]},
      ]
    },
    occupations: function () {
      return [
        {name: 'Architecture and engineering', statevalue: 170000},
        {name: 'Arts, design, entertainment, sports, and media', statevalue: 270000},
        {name: 'Building and grounds cleaning and maintenance', statevalue: 370000},
        {name: 'Business and financial operations specialists', statevalue: 130000},
        {name: 'Community and social service', statevalue: 210000},
        {name: 'Computer and mathematical', statevalue: 150000},
        {name: 'Construction and extraction', statevalue: 470000},
        {name: 'Education, training, and library', statevalue: 250000},
        {name: 'Farmers and farm managers', statevalue: 119013},
        {name: 'Farming, fishing, and forestry', statevalue: 450000},
        {name: 'Food preparation and serving related', statevalue: 350000},
        {name: 'Healthcare practitioners and technicians', statevalue: 290000},
        {name: 'Healthcare support', statevalue: 310000},
        {name: 'Installation, maintenance, and repair', statevalue: 490000},
        {name: 'Legal', statevalue: 230000},
        {name: 'Life, physical, and social science', statevalue: 190000},
        {name: 'Management', statevalue: 110000},
        {name: 'Military Specific', statevalue: 550000},
        {name: 'Office and administrative support', statevalue: 430000},
        {name: 'Personal care and service', statevalue: 390000},
        {name: 'Production', statevalue: 510000},
        {name: 'Protective service', statevalue: 330000},
        {name: 'Sales and related', statevalue: 410000},
        {name: 'Transportation and material moving', statevalue: 530000},
      ]
    }
  },
        methods: {
            setMcd: function (id) {
                this.$emit('mcdInput', id)
            },
            setCounties: function (id) {
                this.$emit('countiesInput', id)
            },
            openToPrint: function () {
                let search = window.location.search || '?';
                let counties = this.counties.map(c => '&county=' + c.statevalue).join('');
                window.open(
                    window.location.pathname + search + '&print=true' + counties,
                    "",
                    "width=1000, height=700, dependent=true"
                );
            }
        },
      watch: {
        mappedAmenity: function () {
          this.selectedAmenity = this.mappedAmenity
          this.flowDirection = this.amenityNames[this.mappedAmenity].defaultFlow || 'Outflow'
        },
        selectedAmenity: function () {
          this.$emit('input', this.selectedAmenity)
        },
        mappedCategory: function () {
          this.selectedCategory = this.mappedCategory
        },
        selectedCategory: function () {
          this.$emit('categoryInput', this.selectedCategory)
        },
        flowDirection: function () {
          this.$emit('flowDirection', this.flowDirection)
        },
        expanded: function () {
          this.$emit('expandedInput', this.expanded)
        },
      }
    }
</script>

<style scoped>
    select {
        border-color: #f3f3f3;
    }

    select:focus {
        outline: 0;
        border-color: black;
    }

    select {
        border-radius: 10px;
        min-width: 0;
    }

    select option {
        font-size: 1rem;
    }

    button {
      background: #888787;
      border: 1px solid #FFFFFF;
      border-radius: 5px;
      padding: 9px;
      color: white;
      font-size: 14px;
    }

    .workplace_button {
      padding: 5px;
    }

    button:hover {
      background: #1a2f0b;
    }

    button:disabled {
      background: #64983D;
      padding-bottom: 7px;
      border-bottom: 5px solid #000000;
    }

    .about {
        float: right;
        padding: 5px;
        color: black;
    }

    @media screen {
        div.expanded {
            position: fixed;
            background: rgba(46, 60, 67, 0.8);
            display: flex;
            align-items: center;
            justify-content: center;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            z-index: 3;
            opacity: 1;
            overflow: hidden;
            backdrop-filter: blur(35px);
        }

        .expanded-content {
            background: white;
            max-width: 60%;
            border: #fffcfc solid 2px;
            border-radius: 10px;
            padding: 10px 30px;
            max-height: 80%;
            overflow: auto;
        }
    }

    .control-title {
        font-weight: bold;
        font-size: large;
    }

    .slidecontainer {
        width: 100%;
    }

    .mode-ticks {
        display: grid;
        width: 100%;
        grid-template-columns: min-content min-content min-content min-content;
        justify-content: space-between;
        margin-bottom: -45px;
        padding: 0 calc(29px - .7em);
    }

    @media print {
        .slidecontainer>div {
            display: inline-block;
        }
        .mode-ticks {
            margin-bottom: 0;
            display: inline-block;
        }
    }

    .mode-ticks div {
        text-align: center;
        justify-self: center;
    }

    .slider {
        -webkit-appearance: none;
        width: 100%;
        height: 50px;
        border-radius: 20px;
        background: #d3d3d3;
        outline: none;
        opacity: 0.5;
        -webkit-transition: .2s;
        transition: opacity .2s;
    }

    .slider:hover {
        opacity: 0.3;
    }

    .slider::-webkit-slider-thumb {
        -webkit-appearance: none;
        appearance: none;
        width: 58px;
        height: 65px;
        border-radius: 20px;
        background: #64983D;
        cursor: pointer;
    }

    .slider::-moz-range-thumb {
        width: 58px;
        height: 65px;
        border-radius: 20px;
        background: #64983D;
        cursor: pointer;
    }

    .amenityIcon {
        height: 35px;
        width: 35px;
        vertical-align: bottom;
        margin-left: 7px;
    }

    .mode-label {
        font-size: 0.5em
    }

    .result-button{
        float: right;
        height: 30px;
        background: rgba(100, 152, 61, 0.75);
        border-color: rgba(100, 152, 61, 0.75);
    }

    .group {
        padding: 5px;
    }

    @media print {
        .no-print {
            display: none;
        }
    }

    @media screen and (max-width: 800px) {
        .expanded-content {
            position: relative;
        }

        div.expanded {
            z-index: 33;
        }
    }

    @media screen and (max-width: 1000px) {
        .control-title {
            font-size: small;
            display: inline-block;
        }

        .expanded-content {
            max-width: 80%;
            max-height: 100%;
        }

    }
</style>
